module.exports = __webpack_public_path__ + "static/media/hu.e5e334fd.svg";